import React from "react";
import Skeleton from "react-loading-skeleton";

const PersonaManagementTable = ({
  searchText,
  setSearchText,
  filteredPersonas,
  isLoading,
  errorMessage,
  deletingPersonaId,
  onDeletePersona,
  onEditPersona,
  onAddReport,
}) => {
  const renderSkeletonRows = () =>
    Array.from({ length: 5 }).map((_, rowIndex) => (
      <tr key={`skeleton-row-${rowIndex}`}>
        {Array.from({ length: 4 }).map((__, colIndex) => (
          <td key={`skeleton-cell-${rowIndex}-${colIndex}`}>
            <Skeleton height={20} />
          </td>
        ))}
      </tr>
    ));

  const hasNoResults = !isLoading && !errorMessage && filteredPersonas.length === 0;

  return (
    <div className="container-fluid pb-4">
      <div className="rr-manageCard">
        <div className="rr-manageHeader">
          <div>
            <h5 className="mb-1">Persona Management</h5>
            <p className="mb-0 text-muted">
              Review and manage registered personas.
            </p>
          </div>
          <input
            type="text"
            className="form-control rr-manageSearch"
            placeholder="Search by persona name"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
          />
        </div>

        <div className="table-responsive mt-3">
          <table className="table rr-table mb-0 table-hover table-collapsed">
            <thead>
              <tr>
                <th>Persona Name</th>
                <th>Created By</th>
                <th>Created At</th>
                <th style={{textAlign:"center"}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                renderSkeletonRows()
              ) : errorMessage ? (
                <tr>
                  <td colSpan="4" className="text-center text-danger py-4">
                    Unable to load personas. {errorMessage}
                  </td>
                </tr>
              ) : hasNoResults ? (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-4">
                    {searchText.trim()
                      ? "No matching personas found."
                      : "No personas available."}
                  </td>
                </tr>
              ) : (
                filteredPersonas.map((persona) => (
                  <tr key={persona.id}>
                    <td>{persona.name}</td>
                    <td>{persona.createdBy}</td>
                    <td>{persona.createdAt}</td>
                      <td className="rr-actionsCol" style={{ width: "20%" }}>
                        <div className="rr-actionsWrap">
                          <button
                            type="button"
                            className="btn"
                            style={{ backgroundColor: "#d8f5e9", color: "#14653a" ,border: "1px solid #14653a"}}
                            disabled={Boolean(deletingPersonaId)}
                            onClick={() => onAddReport(persona)}
                          >
                            Add Report
                          </button>
                          <button
                            type="button"
                            className="btn"
                            style={{ backgroundColor: "#cddef1", color: "#264a5d" ,border: "1px solid #264a5d"}}
                            disabled={Boolean(deletingPersonaId)}
                            onClick={() => onEditPersona(persona)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn"
                            style={{ backgroundColor: "#fbe9ea", color: "#a70e13" ,border: "1px solid #a70e13"}}
                            disabled={Boolean(deletingPersonaId)}
                            onClick={() => onDeletePersona(persona)}
                          >
                            {String(deletingPersonaId) === String(persona.id) ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Deleting...
                              </>
                            ) : (
                              "Delete"
                            )}
                          </button>
                        </div>
                      </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PersonaManagementTable;
